import { useEffect, useState, } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getCollaboratorsList, getIsLoading, getModules, getResources, getTree } from "../../selectors";
import {
    getModulesAction,
    updateModuleAction,
} from "../../actions";
import { openSnackbarAction } from "@icarius-common/snackbar/actions";
import { getLocalizedString } from "@icarius-localization/strings";
import { RESET_ALL } from "../../actionTypes";

const useModules = () => {

    const [selectedItem, setSelectedItem] = useState(null);
    const [formIsOpen, setFormIsOpen] = useState(false);
    const [treeDialogIsOpen, setTreeDialogIsOpen] = useState(false);

    const dispatch = useDispatch();
    const isLoading = useSelector(getIsLoading);
    const modules = useSelector(getModules);
    const collaboratorsList = useSelector(getCollaboratorsList);
    const tree = useSelector(getTree);
    const resources = useSelector(getResources);

    useEffect(() => {
        dispatch(getModulesAction());

        return () => {
            dispatch({ type: RESET_ALL });
        }
    }, [dispatch])

    const handleOpenUpdateForm = (gridRef) => {
        let selectedRows = gridRef.api.getSelectedRows();
        if (selectedRows.length !== 1) {
            dispatch(openSnackbarAction({ msg: getLocalizedString("mustSelectOneRow"), severity: "warning" }));
            return;
        }

        setSelectedItem(selectedRows[0]);
        setFormIsOpen(true);
    }

    const handleCloseForm = () => {
        setSelectedItem(null);
        setFormIsOpen(false);
    }

    const handleUpdate = (dataToSend) => {
        dispatch(updateModuleAction(selectedItem.id, dataToSend))
            .then((resp) => {
                if (resp?.status === 200) {
                    handleCloseForm();
                }
            });
    }

    const handleOpenTreeDialog = () => {
        setTreeDialogIsOpen(true);
    }

    const handleCloseTreeDialog = () => {
        setTreeDialogIsOpen(false);
    }

    const state = {
        selectedItem,
        formIsOpen,
        treeDialogIsOpen,
    }

    const handlers = {
        handleOpenUpdateForm,
        handleCloseForm,
        handleUpdate,
        handleOpenTreeDialog,
        handleCloseTreeDialog,
    }

    return {
        isLoading,
        modules,
        collaboratorsList,
        tree,
        resources,
        state,
        handlers,
    }
}

export default useModules;